export enum SearchType {
  CONVERSATIONS = 'conversations',
  PAYMENTS = 'payments',
  PRODUCT_REQUESTS = 'product-requests',
  CLIENTS = 'clients',
  FORM_SUBMISSIONS = 'form-submissions'
}
